import { queryOptions } from "@tanstack/react-query";

import { ProjectHeaderName } from "@/api/ApiClientProvider";
import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useOptionalProjectContext } from "@/providers/ProjectContext";
import { QUERY_KEYS } from "@/query-keys";

export const useProjectQueries = () => {
  const api = useApi();
  const project = useOptionalProjectContext();
  const projectId = project?.projectId;

  return {
    details: (projectIdOverride?: string) => {
      const selectedProjectId = projectIdOverride ?? projectId;
      if (!selectedProjectId) {
        throw new Error("Project details require a project scope");
      }

      return queryOptions({
        queryKey: QUERY_KEYS.PROJECT_DETAILS(selectedProjectId),
        queryFn: () =>
          api.getProjectDetailsV1({
            headers: { [ProjectHeaderName]: selectedProjectId },
          }),
        select: commonAPIDataSelector,
      });
    },
    languagesBase: () =>
      queryOptions({
        queryKey: QUERY_KEYS.LANGUAGES_BASE,
        queryFn: () => api.getLanguagesBaseV1(),
        select: commonAPIDataSelector,
        staleTime: 5 * 60 * 1000,
      }),
  };
};
